export default __webpack_public_path__ + "static/media/batt.3b530194.svg";